/* Sereine welcome offer. No libraries, no external requests, no fonts.
   Why it works this way: sections/sereine-welcome-scratch.liquid + offer/section/README.md. */
(function () {
  var dlg = document.getElementById('SereineWelcome');
  if (!dlg || !dlg.showModal || !window.fetch || !window.URLSearchParams) return;

  var d = dlg.dataset, KEY = 'sereineWelcome', DAY = 864e5;
  var q = function (s) { return dlg.querySelector('[data-swo-' + s + ']'); };
  var card = q('card'), panel = q('panel'), reward = q('reward'), form = dlg.querySelector('form');
  var email = q('email'), submit = q('submit'), msg = q('msg'), live = q('live');
  var codeLine = q('code'), fine = dlg.querySelector('.swo__fine');
  form.hidden = true;                    // shown by reveal(), never before
  form.noValidate = true;                // JS owns validation, so the message lands in the card
  /* Consent is the deliberate act of submitting, so the button may only be reachable with a valid
     address. No tick box: the line under the button carries the notice. */
  function sync() { submit.disabled = !email.value.trim() || !email.checkValidity(); }
  email.addEventListener('input', sync);
  sync();
  var teaser = document.getElementById('SereineWelcomeTeaser');
  var canvas, ctx, drawing, last, checked = 0, revealed = false, opener = null, timer = null;

  function read() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function say(t) { if (live) live.textContent = t; }
  function note(t) { msg.textContent = t; msg.hidden = !t; }
  function showCode(t) { if (!codeLine) return; codeLine.textContent = t || ''; codeLine.hidden = !t; }
  /* 18-09-2026: zet de korting op de sessie/cart, zonder de klant van de pagina te halen. Shopify
     bewaart hem ook bij een lege cart, dus de checkout past hem later automatisch toe. Redirect naar
     /cart.js zodat het antwoord een paar honderd bytes is in plaats van een hele pagina. */
  function applyDiscount() {
    if (!d.code) return Promise.resolve(false);
    return fetch('/discount/' + encodeURIComponent(d.code) + '?redirect=/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return !!r.ok; })
      .catch(function () { return false; });
  }
  function markApplied() {
    reward.textContent = '15% off applied';
    note('You\u2019ll see it at checkout.');
    showCode('Code ' + d.code + ' \u2014 in case you clear cookies');
    if (fine && fine.textContent.indexOf('Applied automatically') === -1) {
      fine.insertBefore(document.createTextNode('Applied automatically at checkout. '), fine.firstChild);
    }
    say('15% off applied. You will see it at checkout. Code ' + d.code + '.');
  }

  var seen = read();
  var subscribed = !!seen.done;                           // already subscribed: never AUTO-show again
  var capped = seen.ts && Date.now() - seen.ts < (+d.days || 7) * DAY;

  /* Async stylesheet: show nothing before it applies, or the page shifts. */
  function ready(fn) {
    if (getComputedStyle(dlg).position === 'fixed') fn();
    else setTimeout(function () { ready(fn); }, 120);
  }

  function open(trigger) {
    if (dlg.open) return;
    opener = trigger || null; clearTimeout(timer);
    ready(function () {
      if (teaser) teaser.hidden = true;
      dlg.showModal();
      card.focus();
      requestAnimationFrame(function () { dlg.classList.add('is-open'); });
      if (!revealed) paint();
    });
  }
  /* 14-09 calm: re-open on demand from the announcement slide (a[href="#welcome-offer"]) or any
     [data-welcome-open]. Delegated on document, so Dawn's slider clones are covered too. Works while
     the 7-day cap runs. Already subscribed -> open straight in the revealed state with the code and
     no email form, so she can copy it. preventDefault keeps the hash out of the URL (no jump). */
  function showSubscribed() {
    revealed = true;
    dlg.classList.add('is-revealed');
    reward.removeAttribute('aria-hidden');
    form.hidden = true; q('fair').hidden = true;
    var r = dlg.querySelector('[data-swo-reveal]'); if (r) r.hidden = true;
    reward.textContent = d.code || 'Your code is on its way to your inbox';
    note(d.code ? 'Your welcome code — use it at checkout.' : 'Your code is in your inbox.');
    /* 18-09-2026: opnieuw op de sessie zetten — wie zijn cookies wiste, heeft hem niet meer. */
    if (d.code) applyDiscount().then(function (ok) { if (ok) markApplied(); });
  }
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('a[href="#welcome-offer"], a[href$="#welcome-offer"], [data-welcome-open]') : null;
    if (!t) return;
    e.preventDefault();
    if (read().done) showSubscribed();
    open(t);
  });

  dlg.addEventListener('close', function () {
    dlg.classList.remove('is-open');
    if (!read().done) {
      save({ done: false, ts: Date.now() });              // frequency cap starts at dismissal
      if (teaser && d.teaser === 'true') teaser.hidden = false;
    }
    var back = opener || teaser;
    if (back && back.focus) back.focus();
  });

  /* ---------- scratch ---------- */
  function paint() {
    if (canvas) return;
    var b = panel.getBoundingClientRect();
    if (!b.width) return;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    canvas = document.createElement('canvas');
    canvas.className = 'swo__canvas';
    canvas.setAttribute('aria-hidden', 'true');
    canvas.width = Math.round(b.width * dpr);
    canvas.height = Math.round(b.height * dpr);
    panel.appendChild(canvas);
    ctx = canvas.getContext('2d', { willReadFrequently: true });
    ctx.scale(dpr, dpr);
    ctx.fillStyle = 'rgb(' + ((getComputedStyle(card).getPropertyValue('--color-button') || '62,85,72').trim()) + ')';
    ctx.fillRect(0, 0, b.width, b.height);
    ctx.globalCompositeOperation = 'destination-out';
    ctx.lineCap = ctx.lineJoin = 'round';
    ctx.lineWidth = 26;
    canvas.addEventListener('pointerdown', down);
    canvas.addEventListener('pointermove', move);
    window.addEventListener('pointerup', function () { drawing = false; });
  }
  function at(e) { var b = canvas.getBoundingClientRect(); return { x: e.clientX - b.left, y: e.clientY - b.top }; }
  function down(e) {
    e.preventDefault();
    drawing = true; last = at(e);
    ctx.beginPath(); ctx.arc(last.x, last.y, 13, 0, 6.2832); ctx.fill();
    dlg.classList.add('is-scratched');
    if (canvas.setPointerCapture) { try { canvas.setPointerCapture(e.pointerId); } catch (err) {} }
  }
  function move(e) {
    if (!drawing || !last) return;
    e.preventDefault();
    var p = at(e);
    ctx.beginPath(); ctx.moveTo(last.x, last.y); ctx.lineTo(p.x, p.y); ctx.stroke();
    last = p;
    var now = Date.now();
    if (now - checked < 140) return;                      // throttle the costly getImageData
    checked = now;
    if (cleared() >= 0.45) reveal(false);
  }
  function cleared() {
    var w = canvas.width, h = canvas.height, px = ctx.getImageData(0, 0, w, h).data, gone = 0, n = 0;
    for (var y = 0; y < h; y += 6) {
      for (var x = 0; x < w; x += 6) { n++; if (px[(y * w + x) * 4 + 3] < 40) gone++; }
    }
    return n ? gone / n : 0;
  }
  function reveal(fromButton) {
    if (revealed) return;
    revealed = true;
    dlg.classList.add('is-revealed');
    reward.removeAttribute('aria-hidden');
    if (canvas) { canvas.classList.add('is-gone');
      setTimeout(function () { if (canvas) { panel.removeChild(canvas); canvas = null; } }, 380); }
    form.hidden = false;
    say(d.reward + '. Enter your email to unlock your code.');
    /* From the button only: on a phone the keyboard would cover the card. */
    if (fromButton) setTimeout(function () { email.focus({ preventScroll: true }); }, 140);
  }

  /* ---------- subscribe: Shopify's own {% form 'customer' %}, posted with fetch ---------- */
  /* Only Shopify's own success redirect counts. Strict on purpose. */
  function accepted(res) { return res.ok && (res.url || '').indexOf('customer_posted=true') > -1; }
  function done() {
    save({ done: true, ts: Date.now() });
    form.hidden = true; q('fair').hidden = true;
    reward.textContent = d.code || 'Your code is on its way to your inbox';
    /* 18-09-2026: geen mail-belofte. Eerst de code-tekst (de terugval), daarna pas "applied" zodra de
       fetch naar /discount/<code> echt is gelukt — nooit een valse "toegepast"-melding. */
    note(d.code ? 'Your code: ' + d.code + ' — use it at checkout.'
               : 'You are in. We will send your code by email.');
    if (teaser && teaser.parentNode) teaser.parentNode.removeChild(teaser);
    say('Subscribed. ' + reward.textContent);
    card.focus();
    if (d.code) applyDiscount().then(function (ok) { if (ok) markApplied(); });
  }
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    if (form.dataset.busy) return;
    if (submit.disabled) return;
    note('');
    form.dataset.busy = '1';
    submit.disabled = true;
    submit.textContent = 'Sending…';
    fetch(form.action, {
      method: 'POST', credentials: 'same-origin', headers: { Accept: 'text/html' },
      body: new URLSearchParams(new FormData(form))
    })
      .then(function (res) { if (!accepted(res)) throw 0; })
      .then(done)
      .catch(function () {
        form.dataset.busy = '';
        submit.textContent = d.cta;
        sync();
        note('That did not go through. Please try again in a moment.');
      });
  });

  dlg.addEventListener('click', function (e) {
    if (e.target === dlg || e.target.closest('[data-swo-close]')) dlg.close();  // backdrop, X or ESC
    else if (e.target.closest('[data-swo-reveal]')) reveal(true);
  });
  if (teaser) teaser.addEventListener('click', function () { open(teaser); });

  var views = 1;
  try { views = (+sessionStorage.getItem('sereineWelcomeViews') || 0) + 1;
        sessionStorage.setItem('sereineWelcomeViews', views); } catch (e) {}

  if (subscribed) { if (teaser && teaser.parentNode) teaser.parentNode.removeChild(teaser); return; }
  if (teaser && d.teaser === 'true') {
    setTimeout(function () { ready(function () { if (!dlg.open) teaser.hidden = false; }); }, 1500);
  }
  if (!capped && views >= (+d.views || 2)) timer = setTimeout(open, (+d.delay || 20) * 1000);
})();
